import base_ds from "@/services/base_datasource_service";
import request from "@/utils/request";
import { imbalanceColorStore } from "@/utils/imbalanceColorStore";
import { AxiosResponse } from "axios";

export const route_ns = `imbalance`;


class ImbalanceService {
  public crud = base_ds.getBaseCrud(route_ns);

  public async getStruct(id_cut: string, id_eco_facility: number, months: string[]) {
    const route = route_ns+`/gettt?id_cut=${id_cut}&id_eco_facility=${id_eco_facility}&months=${JSON.stringify(months)}`;
    const response: AxiosResponse["data"] = await request({
        url: route,
        method: "get",
      });
    if (response) {
      return response;
    } else {
      return { data: null };
    }
  }

  public async getImbalanceColors(): Promise<Record<string, any>> {
    const response: AxiosResponse["data"] = await request({
      url: "/imbalance_color",
      method: "get",
    });

    imbalanceColorStore.set(response); // сохраняем в хранилище
    return response;
  }

  public async updateImbalanceColors(data: Record<string, any>): Promise<boolean> {
    try {
      await request({
        url: "/imbalance_color",
        method: "put",
        data,
      });

      // после обновления — снова обновляем локальное хранилище
      imbalanceColorStore.set(data);
      return true;
    } catch (e) {
      console.error("Ошибка при сохранении цветов дисбаланса:", e);
      return false;
    }
  }

}

export default new ImbalanceService();
